import CreateNotification from "./CreateNotification";

export default CreateNotification;
